// extracted by mini-css-extract-plugin
module.exports = {"title":"TopHCTrend_title__12IjX","context":"TopHCTrend_context__1dKaY","first":"TopHCTrend_first__W-ikg","second":"TopHCTrend_second__1OFk8"};